module.exports = __webpack_public_path__ + "static/media/edit.13e6de0f.svg";